import React from 'react';

// ANT Design
import { Button, Modal } from 'antd';
import { useStore } from '../../store/store';

const selector = (state) => ({
  pdfCompression: state.pdfCompression,
  isPdfCompressing: state.isPdfCompressing,
  confirmPdfCompression: state.confirmPdfCompression,
  declinePdfCompression: state.declinePdfCompression,
});

const formatSizeMo = (sizeBytes) => {
  if (typeof sizeBytes !== 'number') return null;
  return (sizeBytes / (1024 * 1024)).toFixed(1).replace('.', ',');
};

const PdfCompressionModal = () => {
  const {
    pdfCompression,
    isPdfCompressing,
    confirmPdfCompression,
    declinePdfCompression,
  } = useStore(selector);

  const sizeMo = formatSizeMo(pdfCompression?.sizeBytes);

  return (
    <Modal
      title='Compression du PDF'
      open={!!pdfCompression}
      onCancel={declinePdfCompression}
      closable={!isPdfCompressing}
      maskClosable={false}
      centered
      footer={[
        <Button
          key='decline'
          onClick={declinePdfCompression}
          disabled={isPdfCompressing}
        >
          Non, ouvrir tel quel
        </Button>,
        <Button
          key='confirm'
          type='primary'
          onClick={confirmPdfCompression}
          loading={isPdfCompressing}
        >
          Oui, compresser
        </Button>,
      ]}
    >
      <p style={{ marginBottom: 0 }}>
        {sizeMo
          ? `Votre PDF fait ${sizeMo} Mo. Voulez-vous le compresser ?`
          : 'Votre PDF est volumineux. Voulez-vous le compresser ?'}
      </p>
      {isPdfCompressing && (
        <p style={{ marginBottom: 0, marginTop: 8, color: '#888' }}>
          Compression en cours, cela peut prendre quelques secondes…
        </p>
      )}
    </Modal>
  );
};

export default PdfCompressionModal;
